const slugify = require("slugify");

const mySlugify = (input) =>
  slugify(input, { strict: false, remove: /[*+~.()'"!:@]/g, lower: true });

module.exports = mySlugify;
